var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { toast } from "react-toastify";
import { env, redirectionErrorCodes } from "../constants/global.constants";
import { Member } from "../models/auth.model";
import { financialValidationService, financialValidationServiceSubject } from "../pages/auth/financial.validation.pending";
import paths from "../paths";
import { auth, authSubject, loginModalSubject } from "../store/auth.store";
import { loginSubject } from "../store/login.store";
import { ApiService } from "./http.service";
import { Storage } from "./localstorege.service";
import { exceptionModal, gtmUserEvent } from "./misc.functions";
import { modalServiceSubject } from "./modal.service";
import { wssProvider } from "./websocket.service";
export var LoginFromWhere;
(function (LoginFromWhere) {
    LoginFromWhere[LoginFromWhere["LOGIN_PAGE"] = 0] = "LOGIN_PAGE";
    LoginFromWhere[LoginFromWhere["REGISTER_FLOW"] = 1] = "REGISTER_FLOW";
    LoginFromWhere[LoginFromWhere["WS"] = 2] = "WS";
})(LoginFromWhere || (LoginFromWhere = {}));
var AuthService = /** @class */ (function () {
    function AuthService(searchParams, navigate) {
        if (searchParams === void 0) { searchParams = null; }
        if (navigate === void 0) { navigate = null; }
        this.tempRegisterPayload = null;
        this.searchParams = searchParams;
        this.navigate = navigate;
    }
    // Register Props
    AuthService.prototype.register = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var api, submitButton, response, e_1;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.tempRegisterPayload = payload;
                        auth.userValidation = false;
                        api = new ApiService();
                        this.tempRegisterPayload.mobile = this.tempRegisterPayload.mobile.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "");
                        this.tempRegisterPayload.birthday = this.tempRegisterPayload.birthday_year + "-" + this.tempRegisterPayload.birthday_month + "-" + this.tempRegisterPayload.birthday_day;
                        submitButton = document.getElementById("id_btnRegister");
                        if (submitButton) {
                            submitButton.disabled = true;
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 4, 5, 6]);
                        return [4 /*yield*/, api.start("post", env.accounting_api + "/member/api/register/", this.tempRegisterPayload, false)];
                    case 2:
                        response = _a.sent();
                        if (!response.status) {
                            if (response.error === 'validation_token_required') {
                                this.getRegisterSMSValidationCode();
                                return [2 /*return*/];
                            }
                            if (response.error === "invalid_validation_token") {
                                this.tempRegisterPayload.validation_token = undefined;
                                this.getRegisterSMSValidationCode();
                                return [2 /*return*/];
                            }
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata",
                                width: 380,
                                content: "<p>".concat(response.message, "</p>"),
                                confirm: {
                                    cancel: {
                                        label: "Tamam",
                                        class: "btn-danger",
                                    },
                                    sure: redirectionErrorCodes.includes(response.error)
                                        ? {
                                            label: "Giriş yap",
                                            action: function () {
                                                _this.navigate(paths.login.url);
                                            },
                                        }
                                        : null,
                                },
                            });
                            return [2 /*return*/];
                        }
                        gtmUserEvent("sign_up");
                        return [4 /*yield*/, this.loginAfterRegister()];
                    case 3:
                        _a.sent();
                        return [3 /*break*/, 6];
                    case 4:
                        e_1 = _a.sent();
                        modalServiceSubject.next({
                            case: "danger",
                            title: "Hata",
                            width: 380,
                            content: "<p>Beklenmedik bir hata olu\u015Ftu, l\u00FCtfen daha sonra tekrar deneyiniz.</p>",
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-danger",
                                },
                            },
                        });
                        return [3 /*break*/, 6];
                    case 5:
                        if (submitButton) {
                            submitButton.disabled = false;
                        }
                        return [7 /*endfinally*/];
                    case 6: return [2 /*return*/];
                }
            });
        });
    };
    ;
    AuthService.prototype.getRegisterSMSValidationCode = function () {
        return __awaiter(this, void 0, void 0, function () {
            var api, response, e_2;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auth.userValidation = false;
                        api = new ApiService();
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.start("post", env.accounting_api + "/member/api/mobile_validation/", this.tempRegisterPayload, false)];
                    case 2:
                        response = _a.sent();
                        if (!response.status) {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata",
                                width: 380,
                                content: "<p>".concat(response.message, "</p>"),
                                confirm: {
                                    cancel: {
                                        label: "Tamam",
                                        class: "btn-danger",
                                    },
                                    sure: redirectionErrorCodes.includes(response.error)
                                        ? {
                                            label: "Giriş yap",
                                            action: function () {
                                                _this.navigate(paths.login.url);
                                            },
                                        }
                                        : null,
                                },
                            });
                            return [2 /*return*/];
                        }
                        if (response.data.timeout) {
                            this.showRegisterValidationModal(response.data.timeout);
                            return [2 /*return*/, response];
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        e_2 = _a.sent();
                        modalServiceSubject.next({
                            case: "danger",
                            title: "Hata",
                            width: 380,
                            content: "<p>Beklenmedik bir hata olu\u015Ftu, l\u00FCtfen daha sonra tekrar deneyiniz.</p>",
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-danger",
                                },
                            },
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    AuthService.prototype.loginAfterRegister = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.tempRegisterPayload) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.login({
                                user: this.tempRegisterPayload.tc_id,
                                password: this.tempRegisterPayload.password,
                                remember: true,
                            }, LoginFromWhere.REGISTER_FLOW)];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    ;
    AuthService.prototype.showRegisterValidationModal = function (timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 180; }
        if (!this.tempRegisterPayload) {
            return;
        }
        var mobile = this.tempRegisterPayload.mobile;
        var s = null;
        var sureButton = null;
        var resendButton = null;
        var validationErrorMessage = null;
        var senderTimer = function () {
            var resendTimer = document.getElementById("id_resendTimer");
            if (resendTimer) {
                var secondLeft = Number(Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1);
                if (secondLeft < 0) {
                    if (s) {
                        clearInterval(s);
                        s = null;
                    }
                    if (resendButton) {
                        resendButton.style.visibility = "visible";
                    }
                }
                else {
                    resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
                }
            }
        };
        var formatTime = function (seconds) {
            return Math.floor(seconds / 60) + ":" + ("00" + (seconds % 60)).slice(-2);
        };
        modalServiceSubject.next({
            title: "Cep Numaranızı Doğrulayın",
            confirm: {
                sure: {
                    label: "Doğrula",
                    autoClose: false,
                    async: true,
                    action: function () { return __awaiter(_this, void 0, void 0, function () {
                        var inputElements, validateCodeValue, validationResponse, e_3;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!validationErrorMessage) {
                                        validationErrorMessage = document.getElementById("id_validationErrorMessage");
                                    }
                                    if (validationErrorMessage) {
                                        validationErrorMessage.style.display = "none";
                                    }
                                    inputElements = document.querySelectorAll("input.code-input");
                                    validateCodeValue = __spreadArray([], inputElements, true).map(function (inp) { return inp.value; }).join("");
                                    if (validateCodeValue.length !== 6) {
                                        if (validationErrorMessage) {
                                            validationErrorMessage.innerHTML = "Lütfen doğrulama kodunu eksiksiz giriniz.";
                                            validationErrorMessage.style.display = "block";
                                        }
                                    }
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 5, , 6]);
                                    return [4 /*yield*/, this.validateMobile(this.tempRegisterPayload, validateCodeValue)];
                                case 2:
                                    validationResponse = _a.sent();
                                    console.log(validationResponse);
                                    if (validationResponse === null || validationResponse === undefined) {
                                        if (validationErrorMessage) {
                                            validationErrorMessage.innerHTML = 'Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.';
                                            validationErrorMessage.style.display = "block";
                                        }
                                        return [2 /*return*/];
                                    }
                                    if (validationResponse.status === false) {
                                        if (validationErrorMessage) {
                                            validationErrorMessage.innerHTML = validationResponse.message || "Doğrulama kodu geçersiz, lütfen kontrol ediniz.";
                                            validationErrorMessage.style.display = "block";
                                        }
                                        return [2 /*return*/];
                                    }
                                    if (!this.tempRegisterPayload) return [3 /*break*/, 4];
                                    this.tempRegisterPayload.validation_token = validationResponse.data.validation_token;
                                    modalServiceSubject.next(null);
                                    return [4 /*yield*/, this.register(this.tempRegisterPayload)];
                                case 3:
                                    _a.sent();
                                    _a.label = 4;
                                case 4: return [3 /*break*/, 6];
                                case 5:
                                    e_3 = _a.sent();
                                    if (validationErrorMessage) {
                                        validationErrorMessage.innerHTML = 'Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.';
                                        validationErrorMessage.style.display = "block";
                                    }
                                    return [3 /*break*/, 6];
                                case 6: return [2 /*return*/];
                            }
                        });
                    }); },
                },
            },
            onClose: function () {
                if (s) {
                    clearInterval(s);
                    s = null;
                }
            },
            afterLoad: function () {
                if (s) {
                    clearInterval(s);
                }
                s = setInterval(senderTimer, 1000);
                validationErrorMessage = document.getElementById("id_validationErrorMessage");
                if (validationErrorMessage) {
                    validationErrorMessage.style.display = "none";
                }
                sureButton = document.getElementById("id_btnModelServiceSure");
                resendButton = document.getElementById("id_resendCode");
                if (sureButton) {
                    sureButton.disabled = true;
                }
                if (resendButton) {
                    resendButton.style.visibility = "hidden";
                    resendButton.addEventListener("click", function (e) { return __awaiter(_this, void 0, void 0, function () {
                        var resendTimer, response;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    resendButton.style.visibility = "hidden";
                                    resendTimer = document.getElementById("id_resendTimer");
                                    if (!resendTimer) return [3 /*break*/, 2];
                                    if (validationErrorMessage) {
                                        validationErrorMessage.style.display = "none";
                                    }
                                    return [4 /*yield*/, this.getRegisterSMSValidationCode()];
                                case 1:
                                    response = _a.sent();
                                    if (response && response.data && response.data.timeout) {
                                        resendTimer.innerHTML = formatTime(response.data.timeout);
                                        if (s) {
                                            clearInterval(s);
                                        }
                                        s = setInterval(senderTimer, 1000);
                                    }
                                    _a.label = 2;
                                case 2: return [2 /*return*/];
                            }
                        });
                    }); });
                }
                var inputElements = document.querySelectorAll("input.code-input");
                inputElements.forEach(function (ele, index) {
                    ele.addEventListener("keydown", function (e) {
                        // if the keycode is backspace & the current field is empty
                        // focus the input before the current. Then the event happens
                        // which will clear the "before" input box.
                        if (e.keyCode === 8 && e.target.value === "")
                            inputElements[Math.max(0, index - 1)].focus();
                    });
                    ele.addEventListener("input", function (e) {
                        // take the first character of the input
                        // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
                        // but I'm willing to overlook insane security code practices.
                        var _a = e.target.value, first = _a[0], rest = _a.slice(1);
                        e.target.value = first !== null && first !== void 0 ? first : ""; // first will be undefined when backspace was entered, so set the input to ""
                        var lastInputBox = index === inputElements.length - 1;
                        var didInsertContent = first !== undefined;
                        if (didInsertContent && !lastInputBox) {
                            // continue to input the rest of the string
                            inputElements[index + 1].focus();
                            // inputElements[index+1].value = rest.join('')
                            inputElements[index + 1].dispatchEvent(new Event("input"));
                        }
                        var validateCodeValue = __spreadArray([], inputElements, true).map(function (inp) { return inp.value; }).join("");
                        if (validateCodeValue.length === 6) {
                            sureButton.disabled = false;
                        }
                        else {
                            sureButton.disabled = true;
                        }
                    });
                });
            },
            content: "\n              <p>\n                ".concat(mobile, " GSM numaral\u0131 telefonunuza g\u00F6nderdi\u011Fimiz do\u011Frulama kodunu giriniz.\n              </p>\n              <div>\n              \n                <div id=\"id_validationErrorMessage\" class=\"text-center alert alert-danger\"></div>\n                  \n                <div class=\"mb-3 d-flex justify-content-center\" style=\"gap: 2px; padding: 4px 16px; flex-wrap: nowrap; overflow-x: auto; -webkit-overflow-scrolling: touch;\">\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                </div>\n                <div id=\"emailHelp\" class=\"form-text mt-3\"><span id=\"id_resendTimer\">").concat(formatTime(timeout), "</span> sonra tekrar g\u00F6nder</div>\n                <button class=\"btn btn-warning mt-2 w-100\" id=\"id_resendCode\">Tekrar G\u00F6nder</button>\n              </div>"),
        });
    };
    // Login Props
    AuthService.prototype.login = function (payload, fromWhere) {
        return __awaiter(this, void 0, void 0, function () {
            var api;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        api = new ApiService();
                        return [4 /*yield*/, api
                                .start("post", env.accounting_api + "/member/api/login/", payload, false)
                                .then(function (res) {
                                if (res && res.status) {
                                    auth.member = new Member(res.data.member);
                                    loginSubject.next(new Member(res.data.member));
                                    auth.token = res.data.token;
                                    auth.authentication = true;
                                    Storage.set("token", res.data.token);
                                    Storage.set("member", res.data.member);
                                    Storage.del("financial_validation_message_data");
                                    financialValidationService.data = null;
                                    financialValidationServiceSubject.next(false);
                                    authSubject.next({ action: "login" });
                                    wssProvider.user(auth.token);
                                    if (fromWhere === LoginFromWhere.REGISTER_FLOW) {
                                        try {
                                            // @ts-ignore
                                            fbq("track", "CompleteRegistration");
                                            if (_this.tempRegisterPayload && _this.tempRegisterPayload.reference_id) {
                                                _this.navigate(paths.giftTicket.url);
                                            }
                                        }
                                        catch (e) { }
                                    }
                                    _this.tempRegisterPayload = null;
                                }
                                else {
                                    if (fromWhere === LoginFromWhere.LOGIN_PAGE) {
                                        switch (res.error) {
                                            case "sms_validate":
                                                // login bunu kendisi handle edecek
                                                break;
                                            case "financial_validation":
                                                _this.navigate(paths.home.url);
                                                financialValidationService.data = payload;
                                                financialValidationServiceSubject.next(true);
                                                Storage.set("financial_validation_message_data", JSON.stringify(res.data));
                                                wssProvider.setFinancialValidationListener(res.data.key);
                                                break;
                                            default:
                                                return { status: false, error: res.error, message: res.message, data: null };
                                        }
                                    }
                                    ;
                                    if (fromWhere === LoginFromWhere.WS) {
                                        if (res.status) {
                                            _this.navigate(paths.home.url);
                                        }
                                        else {
                                            switch (res.error) {
                                                case "sms_validate":
                                                    _this.getLoginSMSValidationCode(res.data);
                                                    break;
                                                case "financial_validation":
                                                    financialValidationServiceSubject.next(true);
                                                    Storage.set("financial_validation_message_data", JSON.stringify(res.data.key));
                                                    wssProvider.setFinancialValidationListener(res.data.key);
                                                    break;
                                                default:
                                                    modalServiceSubject.next({
                                                        title: "Hata",
                                                        content: res.message || "Beklenmeyen bir hata oluştu, lütfen daha sonra tekrar deneyiniz.",
                                                    });
                                                    break;
                                            }
                                        }
                                    }
                                    ;
                                    if (fromWhere === LoginFromWhere.REGISTER_FLOW) {
                                        switch (res.error) {
                                            case "sms_validate":
                                                _this.getRegisterSMSValidationCode();
                                                break;
                                            case "financial_validation":
                                                _this.navigate(paths.home.url);
                                                financialValidationService.data = _this.tempRegisterPayload;
                                                financialValidationServiceSubject.next(true);
                                                Storage.set("financial_validation_message_data", JSON.stringify(res.data.key));
                                                wssProvider.setFinancialValidationListener(res.data.key);
                                                break;
                                            default:
                                                modalServiceSubject.next({
                                                    case: "danger",
                                                    title: "Giriş Hatası",
                                                    content: res.message || "Beklenmedik bir hata oluştu, lütfen daha sonra tekrar deneyiniz.",
                                                    confirm: {
                                                        cancel: {
                                                            label: "Tamam",
                                                            class: "btn-danger",
                                                        },
                                                    },
                                                });
                                                break;
                                        }
                                    }
                                    ;
                                }
                                return res;
                            })
                                .catch(function (e) {
                                return { status: false, error: e, message: e, data: null };
                            })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    ;
    AuthService.prototype.getLoginSMSValidationCode = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var api, response, e_4;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auth.userValidation = false;
                        api = new ApiService();
                        if (payload.mobile) {
                            payload.mobile = payload.mobile.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "");
                        }
                        if (payload.code) {
                            payload.code = payload.code.replaceAll(" ", "");
                        }
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.start("post", env.accounting_api + "/member/api/mobile_validation/", payload, false)];
                    case 2:
                        response = _a.sent();
                        if (!response.status) {
                            modalServiceSubject.next({
                                case: "danger",
                                title: "Hata",
                                width: 380,
                                content: "<p>".concat(response.message, "</p>"),
                                confirm: {
                                    cancel: {
                                        label: "Tamam",
                                        class: "btn-danger",
                                    },
                                    sure: redirectionErrorCodes.includes(response.error)
                                        ? {
                                            label: "Giriş yap",
                                            action: function () {
                                                _this.navigate(paths.login.url);
                                            },
                                        }
                                        : null,
                                },
                            });
                            return [2 /*return*/];
                        }
                        return [2 /*return*/, response];
                    case 3:
                        e_4 = _a.sent();
                        modalServiceSubject.next({
                            case: "danger",
                            title: "Hata",
                            width: 380,
                            content: "<p>Beklenmedik bir hata olu\u015Ftu, l\u00FCtfen daha sonra tekrar deneyiniz.</p>",
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                    class: "btn-danger",
                                },
                            },
                        });
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    AuthService.prototype.sendValidationCode = function (payload) {
        return __awaiter(this, void 0, void 0, function () {
            var api;
            return __generator(this, function (_a) {
                api = new ApiService();
                api
                    .start("post", env.accounting_api + "/member/api/validation-member-sms/", payload, false)
                    .then(function (res) {
                    console.log(res);
                })
                    .catch(function (e) {
                    exceptionModal(e);
                });
                return [2 /*return*/];
            });
        });
    };
    ;
    AuthService.prototype.sendEmailValidationLink = function () {
        return __awaiter(this, void 0, void 0, function () {
            var api;
            return __generator(this, function (_a) {
                api = new ApiService();
                api
                    .start("post", env.accounting_api + "/member/api/validation-email/", {
                    type: "register_send",
                    email: auth.member.email,
                    return_address: "".concat(window.location.protocol, "//").concat(window.location.host).concat(paths.verifyEmail.url),
                }, true)
                    .then(function (res) {
                    console.log(res);
                    if (res && res.status) {
                        modalServiceSubject.next({
                            title: res.message,
                            content: "<p>L\u00FCtfen eposta adresinize g\u00F6nderilen do\u011Frulama linkini t\u0131klayarak do\u011Frulama i\u015Fleminizi tamamlay\u0131n. \n                    E\u011Fer bir eposta almazsan\u0131z l\u00FCtfen m\u00FC\u015Fteri hizmetlerinden destek talep ediniz. </p>",
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                },
                            },
                        });
                    }
                    else {
                        modalServiceSubject.next({
                            case: 'danger',
                            title: 'Doğrulama Maili Gönderilemedi',
                            content: "<p>".concat(res.message, "<p/>"),
                            confirm: {
                                cancel: {
                                    label: "Tamam",
                                },
                            },
                        });
                    }
                });
                return [2 /*return*/];
            });
        });
    };
    ;
    AuthService.prototype.getGameRemains = function () {
        return __awaiter(this, void 0, void 0, function () {
            var api;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(auth.member && auth.token)) return [3 /*break*/, 2];
                        api = new ApiService();
                        return [4 /*yield*/, api.start('', env.accounting_api + '/misc/api/list-game-reminder/', {}, true).then(function (res) {
                                if (res && res.status) {
                                    auth.remaining_games = res.data.map(function (el, key) {
                                        return el.game_id;
                                    });
                                    // console.log(auth.remaining_games)
                                    authSubject.next({ action: 'checkAuth' });
                                }
                            }).catch(function (e) {
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    ;
    AuthService.prototype.logUtm = function () {
        return __awaiter(this, void 0, void 0, function () {
            var api, parameters, e_5;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        api = new ApiService();
                        parameters = '';
                        if (Storage.get('utm_source')) {
                            parameters += '?utm_source=' + Storage.get('utm_source');
                        }
                        if (Storage.get('utm_medium')) {
                            parameters += '&utm_medium=' + Storage.get('utm_medium');
                        }
                        if (Storage.get('utm_campaign')) {
                            parameters += '&utm_campaign=' + Storage.get('utm_campaign');
                        }
                        if (Storage.get('utm_content')) {
                            parameters += '&utm_content=' + Storage.get('utm_content');
                        }
                        if (auth.member) {
                            parameters += '&user_id=' + auth.member.id;
                        }
                        return [4 /*yield*/, api
                                .start("get", env.accounting_api + "/member/api/utm/" + parameters, {}, false).then(function (res) {
                            })];
                    case 1:
                        _a.sent();
                        return [3 /*break*/, 3];
                    case 2:
                        e_5 = _a.sent();
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    ;
    AuthService.prototype.showLoginValidationModal = function (payload, timeout) {
        var _this = this;
        if (timeout === void 0) { timeout = 180; }
        var mobile = payload.mobile;
        var s = null;
        var sureButton = null;
        var resendButton = null;
        var validationErrorMessage = null;
        var senderTimer = function () {
            var resendTimer = document.getElementById("id_resendTimer");
            if (resendTimer) {
                var secondLeft = Number(Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1);
                if (secondLeft < 0) {
                    if (s) {
                        clearInterval(s);
                        s = null;
                    }
                    if (resendButton) {
                        resendButton.style.visibility = "visible";
                    }
                }
                else {
                    resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
                }
            }
        };
        var formatTime = function (seconds) {
            return Math.floor(seconds / 60) + ":" + ("00" + (seconds % 60)).slice(-2);
        };
        modalServiceSubject.next({
            title: "Cep Numaranızı Doğrulayın",
            confirm: {
                sure: {
                    label: "Doğrula",
                    autoClose: false,
                    async: true,
                    action: function () { return __awaiter(_this, void 0, void 0, function () {
                        var inputElements, validateCodeValue, validationResponse, e_6;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!validationErrorMessage) {
                                        validationErrorMessage = document.getElementById("id_validationErrorMessage");
                                    }
                                    if (validationErrorMessage) {
                                        validationErrorMessage.style.display = "none";
                                    }
                                    inputElements = document.querySelectorAll("input.code-input");
                                    validateCodeValue = __spreadArray([], inputElements, true).map(function (inp) { return inp.value; }).join("");
                                    if (validateCodeValue.length !== 6) {
                                        if (validationErrorMessage) {
                                            validationErrorMessage.innerHTML = "Lütfen doğrulama kodunu eksiksiz giriniz.";
                                            validationErrorMessage.style.display = "block";
                                        }
                                    }
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, this.validateMobile(payload, validateCodeValue)];
                                case 2:
                                    validationResponse = _a.sent();
                                    if (!validationResponse || !validationResponse.status) {
                                        if (validationErrorMessage) {
                                            validationErrorMessage.innerHTML = validationResponse.message || "Doğrulama kodu geçersiz, lütfen kontrol ediniz.";
                                            validationErrorMessage.style.display = "block";
                                        }
                                        return [2 /*return*/];
                                    }
                                    return [3 /*break*/, 4];
                                case 3:
                                    e_6 = _a.sent();
                                    if (validationErrorMessage) {
                                        validationErrorMessage.innerHTML = "Doğrulama kodu geçersiz, lütfen kontrol ediniz.";
                                        validationErrorMessage.style.display = "block";
                                    }
                                    return [3 /*break*/, 4];
                                case 4: return [2 /*return*/];
                            }
                        });
                    }); },
                },
            },
            onClose: function () {
                if (s) {
                    clearInterval(s);
                    s = null;
                }
            },
            afterLoad: function () {
                if (s) {
                    clearInterval(s);
                }
                s = setInterval(senderTimer, 1000);
                validationErrorMessage = document.getElementById("id_validationErrorMessage");
                if (validationErrorMessage) {
                    validationErrorMessage.style.display = "none";
                }
                sureButton = document.getElementById("id_btnModelServiceSure");
                resendButton = document.getElementById("id_resendCode");
                if (sureButton) {
                    sureButton.disabled = true;
                }
                if (resendButton) {
                    resendButton.style.visibility = "hidden";
                    resendButton.addEventListener("click", function (e) {
                        // Clear the interval before opening new modal
                        if (s) {
                            clearInterval(s);
                            s = null;
                        }
                        var resendTimer = document.getElementById("id_resendTimer");
                        if (resendTimer) {
                            if (validationErrorMessage) {
                                validationErrorMessage.style.display = "none";
                            }
                            _this.userValidationUpdate(payload, true);
                        }
                    });
                }
                var inputElements = document.querySelectorAll("input.code-input");
                inputElements.forEach(function (ele, index) {
                    ele.addEventListener("keydown", function (e) {
                        // if the keycode is backspace & the current field is empty
                        // focus the input before the current. Then the event happens
                        // which will clear the "before" input box.
                        if (e.keyCode === 8 && e.target.value === "")
                            inputElements[Math.max(0, index - 1)].focus();
                    });
                    ele.addEventListener("input", function (e) {
                        // take the first character of the input
                        // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
                        // but I'm willing to overlook insane security code practices.
                        var _a = e.target.value, first = _a[0], rest = _a.slice(1);
                        e.target.value = first !== null && first !== void 0 ? first : ""; // first will be undefined when backspace was entered, so set the input to ""
                        var lastInputBox = index === inputElements.length - 1;
                        var didInsertContent = first !== undefined;
                        if (didInsertContent && !lastInputBox) {
                            // continue to input the rest of the string
                            inputElements[index + 1].focus();
                            // inputElements[index+1].value = rest.join('')
                            inputElements[index + 1].dispatchEvent(new Event("input"));
                        }
                        var validateCodeValue = __spreadArray([], inputElements, true).map(function (inp) { return inp.value; }).join("");
                        if (validateCodeValue.length === 6) {
                            sureButton.disabled = false;
                        }
                        else {
                            sureButton.disabled = true;
                        }
                    });
                });
            },
            content: "\n              <p>\n                ".concat(mobile, " GSM numaral\u0131 telefonunuza g\u00F6nderdi\u011Fimiz do\u011Frulama kodunu giriniz.\n              </p>\n              <div>\n              \n                <div id=\"id_validationErrorMessage\" class=\"text-center alert alert-danger\"></div>\n                  \n                <div class=\"mb-3 d-flex justify-content-center\" style=\"gap: 2px; padding: 4px 16px; flex-wrap: nowrap; overflow-x: auto; -webkit-overflow-scrolling: touch;\">\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                  <input type=\"tel\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n                </div>\n                <div id=\"emailHelp\" class=\"form-text mt-3\"><span id=\"id_resendTimer\">").concat(formatTime(timeout), "</span> sonra tekrar g\u00F6nder</div>\n                <button class=\"btn btn-warning mt-2 w-100\" id=\"id_resendCode\">Tekrar G\u00F6nder</button>\n              </div>"),
        });
    };
    // Re-Login Props
    AuthService.prototype.restoreLogin = function () {
        return __awaiter(this, void 0, void 0, function () {
            var savedData;
            return __generator(this, function (_a) {
                savedData = Storage.get("member");
                if (savedData) {
                    auth.member = new Member(savedData);
                    auth.token = Storage.get("token");
                    auth.authentication = true;
                    loginSubject.next(new Member(savedData));
                }
                return [2 /*return*/];
            });
        });
    };
    ;
    // Logout Props
    AuthService.prototype.logout = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                console.log("LOGOUT");
                auth.member = null;
                auth.token = null;
                auth.authentication = false;
                Storage.del("token");
                Storage.del("member");
                authSubject.next({ action: "logout" });
                loginModalSubject.next(false);
                window.location.href = "/";
                return [2 /*return*/];
            });
        });
    };
    ;
    // shared
    AuthService.prototype.validateMobile = function (payload, code) {
        return __awaiter(this, void 0, void 0, function () {
            var api, response, e_7;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        auth.userValidation = false;
                        api = new ApiService();
                        payload.mobile = payload.mobile.replaceAll("(", "").replaceAll(")", "").replaceAll(" ", "");
                        payload.code = code.trim().replaceAll(" ", "");
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, api.start("post", env.accounting_api + "/member/api/mobile_validation/", payload, false)];
                    case 2:
                        response = _a.sent();
                        return [2 /*return*/, response];
                    case 3:
                        e_7 = _a.sent();
                        throw e_7;
                    case 4: return [2 /*return*/];
                }
            });
        });
    };
    ;
    AuthService.prototype.userValidationUpdate = function (payload, resend) {
        if (resend === void 0) { resend = false; }
        return __awaiter(this, void 0, void 0, function () {
            var mobile, s, sureButton, resendButton, validationErrorMessage, api, senderTimer;
            var _this = this;
            return __generator(this, function (_a) {
                mobile = payload.mobile;
                s = null;
                sureButton = null;
                resendButton = null;
                validationErrorMessage = null;
                api = new ApiService();
                if (resend) {
                    api
                        .start("post", env.accounting_api + "/member/api/update-account-info/", {
                        mobile: mobile,
                    }, true).then(function (res) {
                        if (res && res.status) {
                            _this.userValidationUpdate(payload);
                        }
                    }).catch(function (e) {
                        exceptionModal(e);
                    });
                }
                senderTimer = function (s) {
                    if (s === void 0) { s = null; }
                    var resendTimer = document.getElementById("id_resendTimer");
                    if (resendTimer) {
                        var secondLeft = Number(Number(resendTimer.innerHTML.split(":")[0]) * 60 + Number(resendTimer.innerHTML.split(":")[1]) - 1);
                        if (secondLeft < 0) {
                            clearInterval(s);
                            if (resendButton) {
                                resendButton.style.visibility = "visible";
                            }
                        }
                        else {
                            resendTimer.innerHTML = Math.floor(secondLeft / 60) + ":" + ("00" + (secondLeft % 60)).slice(-2);
                        }
                    }
                };
                modalServiceSubject.next({
                    disableBackdrop: true,
                    title: "Cep Numaranızı Doğrulayın",
                    closeIcon: true,
                    confirm: {
                        sure: {
                            class: "btn btn-green",
                            label: "Doğrula",
                            autoClose: false,
                            async: true,
                            action: function () { return __awaiter(_this, void 0, void 0, function () {
                                var inputElements, validateCodeValue;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!validationErrorMessage) {
                                                validationErrorMessage = document.getElementById("id_validationErrorMessage");
                                            }
                                            if (validationErrorMessage) {
                                                validationErrorMessage.style.display = "none";
                                            }
                                            inputElements = document.querySelectorAll("input.code-input");
                                            validateCodeValue = __spreadArray([], inputElements, true).map(function (inp) { return inp.value; }).join("");
                                            return [4 /*yield*/, api
                                                    .start("post", env.accounting_api + "/member/api/update-account-info/", {
                                                    mobile: mobile,
                                                    sms_verify_code: validateCodeValue,
                                                }, true)
                                                    .then(function (res) {
                                                    if (res && res.status) {
                                                        auth.mobileValidation = true;
                                                        authSubject.next({ action: "updateMobileValidation" });
                                                        toast.success("Cep telefonu doğrulama işleminiz başarıyla tamamlandı.");
                                                        wssProvider.checkauth();
                                                        return true;
                                                    }
                                                    else {
                                                        if (validationErrorMessage) {
                                                            validationErrorMessage.style.display = "block";
                                                            validationErrorMessage.innerHTML = res.message;
                                                            __spreadArray([], inputElements, true).map(function (inp) { return (inp.value = ""); });
                                                        }
                                                    }
                                                })
                                                    .catch(function (e) {
                                                    if (validationErrorMessage) {
                                                        validationErrorMessage.style.display = "block";
                                                        validationErrorMessage.innerHTML = e;
                                                    }
                                                })];
                                        case 1: return [2 /*return*/, _a.sent()];
                                    }
                                });
                            }); },
                        },
                    },
                    onClose: function () {
                        clearInterval(s);
                    },
                    afterLoad: function () {
                        s = setInterval(senderTimer, 1000);
                        validationErrorMessage = document.getElementById("id_validationErrorMessage");
                        if (validationErrorMessage) {
                            validationErrorMessage.style.display = "none";
                        }
                        sureButton = document.getElementById("id_btnModelServiceSure");
                        resendButton = document.getElementById("id_resendCode");
                        if (sureButton) {
                            sureButton.disabled = true;
                        }
                        if (resendButton) {
                            resendButton.style.visibility = "hidden";
                            resendButton.addEventListener("click", function (e) {
                                // Clear the interval before opening new modal
                                if (s) {
                                    clearInterval(s);
                                    s = null;
                                }
                                var resendTimer = document.getElementById("id_resendTimer");
                                if (resendTimer) {
                                    if (validationErrorMessage) {
                                        validationErrorMessage.style.display = "none";
                                    }
                                    _this.userValidationUpdate(payload, true);
                                }
                            });
                        }
                        var inputElements = document.querySelectorAll("input.code-input");
                        inputElements.forEach(function (ele, index) {
                            ele.addEventListener("keydown", function (e) {
                                // if the keycode is backspace & the current field is empty
                                // focus the input before the current. Then the event happens
                                // which will clear the "before" input box.
                                if (e.keyCode === 8 && e.target.value === "")
                                    inputElements[Math.max(0, index - 1)].focus();
                            });
                            ele.addEventListener("input", function (e) {
                                // take the first character of the input
                                // this actually breaks if you input an emoji like 👨‍👩‍👧‍👦....
                                // but I'm willing to overlook insane security code practices.
                                var _a = e.target.value, first = _a[0], rest = _a.slice(1);
                                e.target.value = first !== null && first !== void 0 ? first : ""; // first will be undefined when backspace was entered, so set the input to ""
                                var lastInputBox = index === inputElements.length - 1;
                                var didInsertContent = first !== undefined;
                                if (didInsertContent && !lastInputBox) {
                                    // continue to input the rest of the string
                                    inputElements[index + 1].focus();
                                    // inputElements[index+1].value = rest.join('')
                                    inputElements[index + 1].dispatchEvent(new Event("input"));
                                }
                                var validateCodeValue = __spreadArray([], inputElements, true).map(function (inp) { return inp.value; }).join("");
                                if (validateCodeValue.length === 6) {
                                    sureButton.disabled = false;
                                }
                                else {
                                    sureButton.disabled = true;
                                }
                            });
                        });
                    },
                    content: "\n      <p>\n        ".concat(mobile, " GSM numaral\u0131 telefonunuza g\u00F6nderdi\u011Fimiz do\u011Frulama kodunu giriniz.\n      </p>\n      <div>\n\n        <div id=\"id_validationErrorMessage\" class=\"text-center alert alert-danger\"></div>\n\n        <div class=\"mb-3 d-flex justify-content-center\" style=\"gap: 2px; padding: 4px 16px; flex-wrap: nowrap; overflow-x: auto; -webkit-overflow-scrolling: touch;\">\n          <input type=\"text\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n          <input type=\"text\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n          <input type=\"text\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n          <input type=\"text\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n          <input type=\"text\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n          <input type=\"text\" autocomplete=\"off\" name='char' maxlength=\"1\" class='code-input' style=\"flex-shrink: 0; width: 30px; height: 50px; text-align: center; font-size: 16px; font-weight: bold; border: 1px solid #ccc; border-radius: 4px; padding: 4px; box-sizing: border-box;\" required/>\n        </div>\n        <div id=\"emailHelp\" class=\"form-text\"><span id=\"id_resendTimer\">3:00</span> sonra tekrar g\u00F6nder</div>\n        <button style=\"bottom: 4px;\" class=\"btn btn-warning\" id=\"id_resendCode\">Tekrar G\u00F6nder</button>\n      </div>"),
                });
                return [2 /*return*/];
            });
        });
    };
    return AuthService;
}());
export { AuthService };
